import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_AGENCY_WORKSPACES_REQUEST = 'FETCH_AGENCY_WORKSPACES_REQUEST';
export const FETCH_AGENCY_WORKSPACES_SUCCESS = 'FETCH_AGENCY_WORKSPACES_SUCCESS';
export const FETCH_AGENCY_WORKSPACES_FAILURE = 'FETCH_AGENCY_WORKSPACES_FAILURE';

export const CREATE_WORKSPACE_OVER_AGENCY_REQUEST = 'CREATE_WORKSPACE_OVER_AGENCY_REQUEST';
export const CREATE_WORKSPACE_OVER_AGENCY_SUCCESS = 'CREATE_WORKSPACE_OVER_AGENCY_SUCCESS';
export const CREATE_WORKSPACE_OVER_AGENCY_FAILURE = 'CREATE_WORKSPACE_OVER_AGENCY_FAILURE';

export const UPDATE_WORKSPACE_REQUEST = 'UPDATE_WORKSPACE_REQUEST';
export const UPDATE_WORKSPACE_SUCCESS = 'UPDATE_WORKSPACE_SUCCESS';
export const UPDATE_WORKSPACE_FAILURE = 'UPDATE_WORKSPACE_FAILURE';

export const UPDATE_WORKSPACE_AGENCY_SUCCESS = 'UPDATE_WORKSPACE_AGENCY_SUCCESS';
export const UPDATE_WORKSPACE_AGENCY_REQUEST = 'UPDATE_WORKSPACE_AGENCY_REQUEST';
export const UPDATE_WORKSPACE_AGENCY_FAILURE = 'UPDATE_WORKSPACE_AGENCY_FAILURE';

export const CREATE_WORKSPACE_AGENCY_REQUEST = 'CREATE_WORKSPACE_AGENCY_REQUEST';
export const CREATE_WORKSPACE_AGENCY_SUCCESS = 'CREATE_WORKSPACE_AGENCY_SUCCESS';
export const CREATE_WORKSPACE_AGENCY_FAILURE = 'CREATE_WORKSPACE_AGENCY_FAILURE';

export const FETCH_WORKSPACES_LIST_REQUEST = 'FETCH_WORKSPACES_LIST_REQUEST';
export const FETCH_WORKSPACES_LIST_SUCCESS = 'FETCH_WORKSPACES_LIST_SUCCESS';
export const FETCH_WORKSPACES_LIST_FAILURE = 'FETCH_WORKSPACES_LIST_FAILURE';

export const DELETE_WORKSPACE_REQUEST = 'DELETE_WORKSPACE_REQUEST';
export const DELETE_WORKSPACE_SUCCESS = 'DELETE_WORKSPACE_SUCCESS';
export const DELETE_WORKSPACE_FAILURE = 'DELETE_WORKSPACE_FAILURE';

export const CREATE_WORKSPACE_REQUEST = 'CREATE_WORKSPACE_REQUEST';
export const CREATE_WORKSPACE_SUCCESS = 'CREATE_WORKSPACE_SUCCESS';
export const CREATE_WORKSPACE_FAILURE = 'CREATE_WORKSPACE_FAILURE';

export const FETCH_WORKSPACE_AGENCY_PRODUCTS_REQUEST = 'FETCH_WORKSPACE_AGENCY_PRODUCTS_REQUEST';
export const FETCH_WORKSPACE_AGENCY_PRODUCTS_SUCCESS = 'FETCH_WORKSPACE_AGENCY_PRODUCTS_SUCCESS';
export const FETCH_WORKSPACE_AGENCY_PRODUCTS_FAILURE = 'FETCH_WORKSPACE_AGENCY_PRODUCTS_FAILURE';

const baseURL = 'v1/workspaces';
export const SET_WORKSPACES = 'SET_WORKSPACES';

export const fetchAgencyWorkspaces = (workspaceId: number, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${workspaceId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_AGENCY_WORKSPACES_REQUEST, FETCH_AGENCY_WORKSPACES_SUCCESS, FETCH_AGENCY_WORKSPACES_FAILURE],
    hideLoadingWidget,
  },
});

export const createWorkspaceOverAgency = (agencyId: number, workspaceRequest: IWorkspaceRequest) => ({
  [CALL_API]: {
    endpoint: `v1/workspace/${agencyId}`,
    method: 'post',
    body: workspaceRequest,
    authenticated: true,
    types: [
      CREATE_WORKSPACE_OVER_AGENCY_REQUEST,
      CREATE_WORKSPACE_OVER_AGENCY_SUCCESS,
      CREATE_WORKSPACE_OVER_AGENCY_FAILURE,
    ],
  },
});

export const createWorkspace = (workspaceRequest: IWorkspaceCreateRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: workspaceRequest,
    authenticated: true,
    types: [CREATE_WORKSPACE_REQUEST, CREATE_WORKSPACE_SUCCESS, CREATE_WORKSPACE_FAILURE],
  },
});

export const updateWorkspace = (workspaceId: number, workspaceRequest: IWorkspaceEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${workspaceId}`,
    method: 'put',
    body: workspaceRequest,
    authenticated: true,
    types: [UPDATE_WORKSPACE_REQUEST, UPDATE_WORKSPACE_SUCCESS, UPDATE_WORKSPACE_FAILURE],
  },
});

export const editWorkspaceAgency = (agencyId: number, workspaceId: number, editAgencyRequest: IEditAgencyRequest) => ({
  [CALL_API]: {
    endpoint: `v1/workspaces/${workspaceId}/agencies/${agencyId}`,
    method: 'put',
    body: editAgencyRequest,
    authenticated: true,
    types: [UPDATE_WORKSPACE_AGENCY_REQUEST, UPDATE_WORKSPACE_AGENCY_SUCCESS, UPDATE_WORKSPACE_AGENCY_FAILURE],
  },
});

export const createWorkspaceAgency = (workspaceId: number, createAgencyRequest: ICreateAgencyRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${workspaceId}/agencies`,
    method: 'post',
    body: createAgencyRequest,
    authenticated: true,
    types: [CREATE_WORKSPACE_AGENCY_REQUEST, CREATE_WORKSPACE_AGENCY_SUCCESS, CREATE_WORKSPACE_AGENCY_FAILURE],
  },
});

export const fetchworkspacesList = (params?: IWorkspaceListParams) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/listing`,
    method: 'get',
    params,
    authenticated: true,
    types: [FETCH_WORKSPACES_LIST_REQUEST, FETCH_WORKSPACES_LIST_SUCCESS, FETCH_WORKSPACES_LIST_FAILURE],
  },
});

export const setWorkspaces = (workspaces: IWorkspaceResponse) => ({
  type: SET_WORKSPACES,
  workspaces,
});

export const deleteWorkspace = (workspaceId: number) => ({
  [CALL_API]: {
    endpoint: `v1/workspaces/${workspaceId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_WORKSPACE_REQUEST, DELETE_WORKSPACE_SUCCESS, DELETE_WORKSPACE_FAILURE],
  },
});

export const fetchWorkspacesAgencyProducts = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/agencies/${agencyId}/config/products`,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_WORKSPACE_AGENCY_PRODUCTS_REQUEST,
      FETCH_WORKSPACE_AGENCY_PRODUCTS_SUCCESS,
      FETCH_WORKSPACE_AGENCY_PRODUCTS_FAILURE,
    ],
  },
});
